import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { SourceFunds } from '../../../../../core';

@JsonConverter
export class SourceFundsAdapter implements JsonCustomConvert<SourceFunds | undefined> {
    serialize(source: SourceFunds): any | undefined {
        return source ? String(source) : undefined;
    }

    deserialize(source: any): SourceFunds | undefined {
        switch (source) {
            case 'PA':
                return SourceFunds.HERITAGE;
            case 'SA':
                return SourceFunds.SALARIES;
            case 'VP':
                return SourceFunds.REAL_ESTATE_SALES;
            case 'HH':
                return SourceFunds.INHERITANCE_OR_SAVINGS;
            case 'TR':
                return SourceFunds.OTHER;
            default:
                return undefined;
        }
    }
}
